import { render } from "./SubjectCategories.vue?vue&type=template&id=5e3410f2&scoped=true"
import script from "./SubjectCategories.vue?vue&type=script&lang=js"
export * from "./SubjectCategories.vue?vue&type=script&lang=js"

import "./SubjectCategories.vue?vue&type=style&index=0&id=5e3410f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3410f2"]])

export default __exports__